import React from 'react'
import {Button} from '@mui/material'
import {Icon} from '@/components/atoms'

const DateRangeCustomInput = React.forwardRef(
  ({value = '', onClick, column, sx, dateRanges, setOpenDatePicker}, ref) => {
    if (!column?.name_of_db_column) return null

    const dateRange = dateRanges[column.name_of_db_column] || {}
    const {startDate, endDate} = dateRange
    const showCross = startDate && endDate
    const showCalendar = !showCross

    let buttonText
    if (startDate && endDate) {
      buttonText = `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
    } else if (startDate) {
      buttonText = `${startDate.toLocaleDateString()} - End Date`
    } else {
      buttonText = value || column.label_of_column
    }

    return (
      <Button
        ref={ref}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          setOpenDatePicker(column.name_of_db_column)
          onClick && onClick(e)
        }}
        variant="outlined"
        size="small"
        fullWidth
        sx={{...sx, textTransform: 'none'}}
        style={{
          borderColor: 'rgba(255, 255, 255, 0.23)',
          color: showCalendar ? 'rgba(255, 255, 255, 0.23)' : '#EFEFEF',
        }}
      >
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}>
          <div style={{fontSize: '12px'}}>{buttonText}</div>
          {showCalendar ? <Icon icon="calendar_today" size="small" /> : null}
        </div>
      </Button>
    )
  }
)

export default DateRangeCustomInput
